import React from 'react'
import PropTypes from 'prop-types'
//MUI
import { create } from 'jss';
import rtl from 'jss-rtl';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';
//Mine
import Header from '../components/Header/HomePageHeader'
import Footer from '../components/Footer/Footer'
import Meta from '../components/Global/Meta/Index'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const THEME = createMuiTheme({
    typography: {
        fontFamily: `"Dana-FaNum", "Tahoma", Arial`,
    },
    direction: 'rtl',
});

class HomeLayout extends React.Component {

    render() {
        const { children, lang, title, description, keywords, metas } = this.props
        return (
            <>
                <title>{title}</title>
                {metas &&
                    Object.entries(metas).map(([key, value]) => {
                        return <meta name={key.toString()} content={value.toString()} />;
                    })}
                <Header lang={lang} />
                <main className="homePage">
                    <MuiThemeProvider theme={THEME}>
                        <StylesProvider jss={jss}>
                            {children}
                        </StylesProvider>
                    </MuiThemeProvider>
                </main>
                <Footer lang={lang} />
            </>
        )
    }

}

HomeLayout.propTypes = {
    children: PropTypes.instanceOf(Object),
    lang: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
}

HomeLayout.defaultProps = {
    children: <></>,
    lang: 'fa',
    title: 'آجیل حسن پور',
    description: 'فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...',
    keywords: 'خرید اینترنتی آجیل,خشکبار',
}

export default HomeLayout
